import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import OrderEditor from '@/routes/orders/OrderEditor'
import { orderEditorRouteAction, orderEditorRouteLoader } from '@/routes/orders/OrderEditor.route'
import { RoleRouteObject } from '@/types'

const OrderCreatorRoute = {
  path: 'new',
  element: <OrderEditor creating={true} isReseller={false} />,
  loader: orderEditorRouteLoader,
  action: orderEditorRouteAction,
  allowedRoles: [Roles.Sales, Roles.Administrator, Roles.GlobalAdministrator, Roles.Supervisor, Roles.Organizer],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default OrderCreatorRoute
